import { defElement, defElements } from "./def.js";
export const blockquote = defElement("blockquote");
export const [div, figure, figcaption, para, pre, template] = defElements([
    "div",
    "figure",
    "figcaption",
    "p",
    "pre",
    "template",
]);
export const hr = defElement("hr");
export const iframe = defElement("iframe");
